<template>
  <div class="about">
    <page-header :title="$t('document.create')" :desc="model.name">
      <li class="breadcrumb-item"><router-link :to="{name:'documents.index'}">{{$tc('document.name', 2)}}</router-link></li>
      <li class="breadcrumb-item">{{$t('action.createNew')}}</li>
    </page-header>
    <page-content>
      <form @submit.prevent="onSubmit()">
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="fields"></formly-form>
          <button class="btn btn-success push-15">{{$t('save')}}</button>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import fields from './formDefinition'
import DocumentService from '@/services/document.service'
import router from '@/router'

export default {
  // required properties, field, form, model
  data () {
    return {
      form: {},
      model: {},
      fields: fields
    }
  },
  methods: {
    onSubmit () {
      DocumentService.store(this.model).then((res) => {
        router.push({ name: 'documents.edit', params: { uuid: res.data.uuid } })
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    }
  }
}
</script>
